/* eslint-disable @typescript-eslint/no-explicit-any */
import { useCurrentRefinements } from 'react-instantsearch'
import SearchBar from '../layout/search/searchBar'

function buildSearchParams(items: any) {
  const params = new URLSearchParams()
  items.forEach((item: any) => {
    const baseAttr = item.attribute.split('.')[0]
    item.refinements.forEach((ref: any, i: number) => {
      params.append(`${baseAttr}[${i}]`, ref.value)
    })
  })
  return '&' + params.toString()
}

export default function HomeSearchBar() {
  const { items } = useCurrentRefinements()
  const filters = buildSearchParams(items)

  return <SearchBar filters={filters} autoFocus={false} />
}
